module.exports = __webpack_public_path__ + "static/media/SF-3-A.7614c9b4.mp3";